import { type CountryCode } from "@airhelp/flags";
import { ActionButton } from "./ActionButton";
import { type ReactNode } from "react";

const FlagBox = ({
  children,
  flagKey,
  locale,
  handleClick,
}: {
  children: ReactNode;
  flagKey: CountryCode;
  locale: string;
  handleClick: () => void;
}) => {
  return (
    <>
      <ActionButton handleClick={handleClick} flagKey={flagKey} locale={locale} />
      {children}
    </>
  );
};

export default FlagBox;
